import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ume-lock-icon',
  standalone: true,
  imports: [MatIconModule],
  styleUrl: './ume-lock-icon.component.scss',
  templateUrl: './ume-lock-icon.component.html',
})
export class UmeLockIconComponent {}
